module.exports = __webpack_public_path__ + "media/images/help/scoring-run-result-graph-eca3231a62c503d791f76b4ab7363366.png";